import Axios from 'axios'
import {facilityContactUrls,facilityRevenueSplitUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_facility_contacts (context, publicId) {
    Axios.get(facilityContactUrls.getAllFacilityContact + publicId).then(function (response) {
      context.commit('GET_ALL_FACILITY_CONTACTS', response.data)
    })
  },
  get_facility_contacts (context, publicId) {
    Axios.get(facilityContactUrls.getAllFacilityContact + publicId).then(function (response) {
      context.commit('GET_FACILITY_CONTACTS', response.data)
    })
  },
  get_active_contacts (context, publicId) {
    Axios.get(facilityContactUrls.getActiveFacilityContact + publicId).then(function (response) {
      context.commit('GET_FACILITY_CONTACTS', response.data)
    })
  },
  get_in_active_contacts (context, publicId) {
    Axios.get(facilityContactUrls.getInActiveFacilityContact + publicId).then(function (response) {
      context.commit('GET_FACILITY_CONTACTS', response.data)
    })
  },
  get_deleted_facility_contacts (context) {
    Axios.get(facilityContactUrls.getDeletedFacilityContact).then(function (response) {
      context.commit('GET_DELETED_FACILITY_CONTACTS', response.data)
    })
  },
  get_facility_contact (context, publicId) {
    Axios.get(facilityContactUrls.getFacilityContact + publicId).then(function (response) {
      context.commit('GET_FACILITY_CONTACT', response.data)
    })
  },
  post_facility_contact (context, data) {
    Axios.post(facilityContactUrls.postFacilityContact, data).then(function () {
      context.dispatch('get_all_facility_contacts', data.facility_id)
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  make_facility_contact_active (context, data) {
    Axios.get(facilityContactUrls.makeFacilityContactActive + data.contact_id).then(function () {
      context.commit('GET_ALL_FACILITY_CONTACTS', {data: []})
      context.dispatch('get_all_facility_contacts', data.facility_id)
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  make_facility_contact_in_active (context, data) {
    Axios.get(facilityContactUrls.makeFacilityContactInActive + data.contact_id).then(function () {
      context.commit('GET_ALL_FACILITY_CONTACTS', {data: []})
      context.dispatch('get_all_facility_contacts', data.facility_id)
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  update_facility_contact (context, data) {
    Axios.post(facilityContactUrls.editFacilityContact, data).then(function () {
      context.dispatch('get_all_facility_contacts')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_a_facility_contact (context, data) {
    Axios.post(facilityContactUrls.deleteFacilityContact + data.public_id, data).then(function (response) {
      context.commit('GET_DELETED_FACILITY_CONTACTS', response.data)
      context.dispatch('get_all_facility_contacts')
    })
  },
  restoreFacilityContact (context, publicId) {
    Axios.get(facilityContactUrls.restoreFacilityContact + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_FACILITY_CONTACTS', response.data)
      router.push({
        name: 'Module.FacilityContacts'
      })
    })
  },
  post_revenue_split (context, data) {
    Axios.post(facilityRevenueSplitUrls.postRevenueSplit, data).then(function () {
      context.dispatch('get_all_revenue_split', data.facility_id)
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  get_all_revenue_split (context, publicId) {
    Axios.get(facilityRevenueSplitUrls.getAllRevenueSplit + publicId).then(function (response) {
      context.commit('GET_FACILITY_REVENUE_SPLIT', response.data)
    })
  },
  delete_facility_split (context, data) {
    Axios.post(facilityRevenueSplitUrls.deleteFacilitySplit + data.public_id, data).then(function (response) {
      context.dispatch('get_all_revenue_split', data.facility_id)
    })
  },
}
